module.exports = __webpack_public_path__ + "img/tailwindComponent3.0432e0da.jpg";